import { __decorate } from "tslib";
import { Component, Prop, Watch } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-center/lang/index';
import { getNumByName } from '@blade-sxp/portrait-center/utils/index';
import CircularEcharts from '@blade-sxp/portrait-center/components/basic-echarts/circular-echarts.vue';
import { brightAgeModeDougnutOption } from '@blade-sxp/portrait-center/utils/dougnut-config';
import { isEmpty } from 'lodash';
import TimeMixin from '@blade-sxp/portrait-center/components/time-mixin.vue';
import { mixins } from 'vue-class-component';
import { PortraitCenterModule } from '@blade-sxp/portrait-center/store/index';
import NoData from '@blade-sxp/portrait-center/pages/components/no-data/index.vue';
import { getFuncVisitorProportion } from '@blade-sxp/portrait-center/utils/common-request';
let default_1 = class default_1 extends mixins(TimeMixin) {
    ageEchartsData = [];
    ageEchartOptions = brightAgeModeDougnutOption();
    dates;
    zoneType;
    recordMode = 'VISIT_OFFLINE_COUNT';
    isLoading = false;
    isNoData = true;
    get zoneId() {
        return PortraitCenterModule.zoneId;
    }
    get sourceType() {
        let value = '';
        if (this.recordMode === 'VISIT_USER_COUNT') {
            if (this.zoneType === 'MAP') {
                value = 'VISIT_USER_COUNT';
            }
            else if (this.zoneType === 'VIRTUAL_AREA') {
                value = 'VA_VISIT_USER_COUNT';
            }
        }
        else if (this.recordMode === 'VISIT_OFFLINE_COUNT') {
            value = 'VISIT_OFFLINE_COUNT';
        }
        return value;
    }
    onChangeDates() {
        this.fetchData();
    }
    onChangeZoneId() {
        this.fetchData();
    }
    mounted() {
        this.fetchData();
    }
    setDefaultData() {
        this.ageEchartsData = [
            { name: this.$t('ST_ADULT'), value: 0 },
            { name: this.$t('ST_OLD'), value: 0 },
            { name: this.$t('ST_CHILD'), value: 0 },
        ];
        this.ageEchartOptions.legend.formatter = (name) => {
            // return `${name}  --%`;
            return `${name}`;
        };
    }
    fetchData() {
        this.isNoData = true;
        if (this.zoneId === 0) {
            return false;
        }
        this.isLoading = true;
        this.setDefaultData();
        getFuncVisitorProportion({
            dateStart: this.dates[0],
            dateEnd: this.dates[1],
            businessId: this.zoneId,
            zoneType: this.zoneType,
            sourceType: this.sourceType,
            attributeType: 'AGE',
        })
            .then((res) => {
            if (res.length > 0) {
                this.setData(res, getNumByName);
            }
            else {
                this.setDefaultData();
            }
        })
            .catch((e) => {
            this.$message.error(e.message || `${this.$t('common.serverError')}`);
        })
            .finally(() => {
            this.isLoading = false;
        });
    }
    setData(data, findFunc) {
        if (isEmpty(data)) {
            return;
        }
        this.isNoData = false;
        data.forEach((item) => {
            this.ageEchartsData = [
                { name: this.$t('ST_ADULT'), value: findFunc(item.data, 'ST_ADULT') },
                { name: this.$t('ST_OLD'), value: findFunc(item.data, 'ST_OLD') },
                { name: this.$t('ST_CHILD'), value: findFunc(item.data, 'ST_CHILD') },
            ];
        });
        // let sum = 0;
        // forEach(this.ageEchartsData, item => { sum += Number(item.value); });
        this.ageEchartOptions.legend.formatter = (name) => {
            // const value = find(this.ageEchartsData, item => item.name === name).value;
            // const percentage = value / sum * 100;
            // return `${name}   ${(Number.isNaN(percentage) ? 0 : percentage).toFixed(2)}%`;
            return `${name}`;
        };
    }
    onModeClick(type) {
        this.recordMode = type;
        this.fetchData();
    }
};
__decorate([
    Prop()
], default_1.prototype, "dates", void 0);
__decorate([
    Prop()
], default_1.prototype, "zoneType", void 0);
__decorate([
    Watch('dates')
], default_1.prototype, "onChangeDates", null);
__decorate([
    Watch('zoneId')
], default_1.prototype, "onChangeZoneId", null);
default_1 = __decorate([
    Component({
        name: 'dougnut',
        components: { CircularEcharts, 'no-data': NoData },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
